import { Form, Formik } from 'formik';
import { INPUT_TYPE } from '@nandosaus/constants';
import { useEffect } from 'react';
import { useRootStore } from '@nandosaus/state-management';
import PropTypes from 'prop-types';

import { Box } from '../grid';
import { Button } from '../button';
import { FormikTextInput } from '../input';
import { P } from '../typography';
import { useSchema } from '../../hooks/use-schema';

const GuestOrderHelpForm = ({ onSubmit }) => {
  const { OrderHelpStore } = useRootStore();
  const initialValues = {
    guestGivenName: OrderHelpStore.guestGivenName ?? '',
    guestFamilyName: OrderHelpStore.guestFamilyName ?? '',
    guestMobile: OrderHelpStore.guestMobile ?? '',
    guestEmail: OrderHelpStore.guestEmail ?? '',
  };
  const validationSchema = useSchema('orderHelpGuestDetails');

  useEffect(() => {
    OrderHelpStore.reset();
  }, [OrderHelpStore]);

  return (
    <>
      <Formik {...{ initialValues, validationSchema, onSubmit: values => onSubmit(values), enableReinitialize: true }}>
        {({ isValid: formIsValid }) => (
          <Form>
            <P variant={3} mb={1}>
              Please provide the following information to find your order:
            </P>
            <Box mb={1}>
              <FormikTextInput name="guestGivenName" label="Name" />
            </Box>
            <Box mb={1}>
              <FormikTextInput name="guestFamilyName" label="Surname" />
            </Box>
            <Box mb={1}>
              <FormikTextInput name="guestEmail" label="Email" type={INPUT_TYPE.EMAIL} />
            </Box>
            <Box mb={1}>
              <FormikTextInput name="guestMobile" label="Mobile phone number" />
            </Box>
            <Button disabled={!formIsValid} type="submit" isFullWidth mb={1}>
              Next
            </Button>
          </Form>
        )}
      </Formik>
    </>
  );
};

GuestOrderHelpForm.propTypes = { onSubmit: PropTypes.func.isRequired };

export { GuestOrderHelpForm };
